import { useEffect, useState } from "react";
import { BellRing, Loader2, Share } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { cardCls, blueBtn } from "@/components/mobile/parts";
import { api, errMsg } from "@/lib/api";
import { currentSub, disablePush, enablePush, isIOS, isStandalone, pushSupported, ring } from "@/lib/push";
import { cn } from "@/lib/utils";

export function PushCard({ manager }) {
  const [sub, setSub] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { currentSub().then(setSub).catch(() => {}); }, []);
  const needInstall = isIOS() && !isStandalone();
  const run = async (fn) => { setBusy(true); try { await fn(); } catch (e) { toast.error(e.response ? errMsg(e) : e.message); } finally { setBusy(false); } };
  const on = () => run(async () => { setSub(await enablePush()); ring(); toast.success("Avisos ativados neste celular"); });
  const off = () => run(async () => { await disablePush(); setSub(null); toast.success("Avisos desativados neste celular"); });
  const test = () => run(async () => { await api.post("/push/test", { endpoint: sub.endpoint }); toast.success("Aviso de teste enviado"); });
  return (
    <div className={cn(cardCls, "space-y-3 p-4")} data-testid="m-push-card">
      <div className="flex items-start gap-3">
        <BellRing className="mt-0.5 h-5 w-5 text-[#1565c0]" />
        <div className="flex-1 text-sm">
          <p className="font-semibold">Avisos de liberação no celular</p>
          <p className="text-xs text-slate-500">{manager ? "Toca e vibra quando um garçom pedir cancelamento ou desconto, mesmo com o app fechado." : "Toca e vibra quando o gerente liberar ou recusar o seu pedido de cancelamento ou desconto, mesmo com o app fechado."}</p>
          <p className="mt-1 text-xs font-semibold" data-testid="m-push-status">{sub ? "Ativado neste celular" : "Desativado neste celular"}</p>
        </div>
      </div>
      {!pushSupported() || needInstall ? (
        <p className="flex items-start gap-2 rounded-xl bg-amber-100 p-3 text-xs text-amber-900" data-testid="m-push-install-hint">
          <Share className="h-4 w-4 shrink-0" />
          {needInstall ? "No iPhone: toque em Compartilhar → \"Adicionar à Tela de Início\", abra o app pelo ícone FSC Comandas e ative aqui. O iPhone toca, mas não vibra pelo navegador." : "Este navegador não aceita notificações. Use o Chrome no Android ou o app instalado no iPhone."}
        </p>
      ) : sub ? (
        <div className="flex gap-2">
          <Button variant="outline" className="h-11 flex-1" disabled={busy} onClick={off} data-testid="m-push-off-btn">Desativar</Button>
          <Button className={cn("h-11 flex-1", blueBtn)} disabled={busy} onClick={test} data-testid="m-push-test-btn">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Enviar teste</Button>
        </div>
      ) : (
        <Button className={cn("h-11 w-full", blueBtn)} disabled={busy} onClick={on} data-testid="m-push-on-btn">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Ativar avisos neste celular</Button>
      )}
    </div>
  );
}
